var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserHover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 13.8333C18.0941 13.8333 19.7917 12.1357 19.7917 10.0417C19.7917 7.94759 18.0941 6.25 16 6.25C13.9059 6.25 12.2083 7.94759 12.2083 10.0417C12.2083 12.1357 13.9059 13.8333 16 13.8333Z",
    fill: "#00FFA3",
    stroke: "#00FFA3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 25.1V25.75H25.75V25.1C25.75 22.6731 25.75 21.4597 25.2777 20.5327C24.8623 19.7173 24.1993 19.0544 23.3839 18.6389C22.457 18.1667 21.2436 18.1667 18.8167 18.1667H13.1833C10.7564 18.1667 9.54301 18.1667 8.61605 18.6389C7.80067 19.0544 7.13775 19.7173 6.72231 20.5327C6.25 21.4597 6.25 22.6731 6.25 25.1Z",
    fill: "#00FFA3",
    stroke: "#00FFA3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserHover);
export default __webpack_public_path__ + "static/media/user_hover.07fbf1801fc5a8aefd9aaad0440a739e.svg";
export { ForwardRef as ReactComponent };